import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import DrinkForm from './DrinkForm'

const DrinCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create>
        <DrinkForm />
      </Create>
    </SectionWrapper>
  )
}

export default DrinCreate
